<script>
export default {
  name: "campaign-details",
  data() {
    return {
      locations: [],
      company_logos: [],
      form: {
        name: null,
        image: null,
        campaign_copy: null,
        terms_conditions: null
      }
    };
  },
  computed: {
    getLocations() {
      return this.$store.getters["getLpmLocations"];
    }
  },
  watch: {
    getLocations(newVal) {
      this.locations = newVal;
    }
  }
};
</script>

<template>
  <div>
    <div
      v-if="locations.length === 0"
      class="alert alert-custom alert-light-danger fade show mb-5"
      role="alert"
    >
      <div class="alert-icon"><i class="flaticon-warning"></i></div>
      <div class="alert-text">Please setup locations in Step 1</div>
      <div class="alert-close">
        <button
          type="button"
          class="close"
          data-dismiss="alert"
          aria-label="Close"
        >
          <span aria-hidden="true"><i class="ki ki-close"></i></span>
        </button>
      </div>
    </div>
    <v-card
      v-if="locations.length > 0"
      class="mx-auto mb-5 p-5"
      max-width="600"
    >
      <b-form
        v-on:submit.prevent="onSubmit"
        method="POST"
        accept-charset="UTF-8"
        enctype="multipart/form-data"
      >
        <b-row>
          <b-col cols="12">
            <b-form-group label="Campaign Name" class="font-weight-bolder">
              <b-form-input
                id="campaign_name"
                v-model="form.name"
                type="text"
                required
                placeholder="Type desired campaign name"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group label="Campaign Logo" class="font-weight-bolder">
              <b-form-text>
                Upload a high resolution business logo and select the locations
                that apply to that logo. If some locations use a different logo,
                click Add and upload the correct logo for those locations.
                (Acceptable dimensions: 80x60, 180x150, 200x65, 200x200,
                240x120)
              </b-form-text>
              <b-form-file
                id="campaign_logo"
                class="company-logo"
                v-model="form.image"
                accept=".jpg, .png, .gif"
              ></b-form-file>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group
              label="Campaign Copy (optional)"
              class="font-weight-bolder"
            >
              <b-form-text>
                Insert any language you'd like to be associated with you
                campaign, like a slogan or short description of your business.
                For example, New York's favorite bakery! (500 character limit)
              </b-form-text>
              <b-form-textarea
                id="campaign_copy"
                v-model="form.campaign_copy"
                placeholder="Enter something..."
                rows="3"
                max-rows="6"
              ></b-form-textarea>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group
              label="Offer Terms and Conditions (optional)"
              class="font-weight-bolder"
            >
              <b-form-text>
                Insert any language a customer should know before redeeming.
                (500 character limit)
              </b-form-text>
              <b-form-textarea
                id="terms_conditions"
                v-model="form.terms_conditions"
                placeholder="Enter something..."
                rows="3"
                max-rows="6"
              ></b-form-textarea>
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
    </v-card>
  </div>
</template>
